import { DeleteFromWishlistDto } from '../../../dto/wishlist/deletefromwishlist/deletefromwishlistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteFromWishlistRequest extends APIRequest
{
    getDeleteFromWishlistRequest(): DeleteFromWishlistDto;
}

export class DeleteFromWishlistRequestImpl extends APIRequestDtoImpl implements DeleteFromWishlistRequest
{
    constructor(private deleteFromWishlistData: DeleteFromWishlistDto)
    {
        super();
    }

    getDeleteFromWishlistRequest(): DeleteFromWishlistDto
    {
        return this.deleteFromWishlistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/deletefromwishlist/deletefromwishlistrequest.tsx